export const textCodes = {

    Address: {
        code: "${merchantId}_tmpl_text_1",
        text: "32,81x82 ကြား ဝါကိုးလ်စတိုးအထည်ဆိုင်"
    },

    copyText: {
        code: "${merchantId}_tmpl_title_2",
        text: "- All right reserved by Ncici"
    },
}

export const titleCodes = {
    AddressTitle: {
        code: "${merchantId}_tmpl_title_1",
        title: "Address"
    },
}